import {
  Concierge,
  ConciergeDashboard,
  ConciergeMembers,
  ConciergeCompanies,
  ConciergeEvents,
  ConciergeBooking,
  ConciergeBookingOrder,
  ConciergeBookingInvoice,
  ConciergeProfile,
  ConciergeSingleMember
} from "@/modules/concierge";

import Logs from "@/components/Logs";

export default [
  {
    path: "/concierge",
    name: "concierge",
    component: Concierge,
    redirect: "/concierge/dashboard",
    meta: {
      isAuthorized: true,
      isMaintainer: true
    },
    children: [
      {
        path: "dashboard",
        name: "Bookings",
        component: ConciergeDashboard
      },
      {
        path: "members",
        name: "concierge-members",
        component: ConciergeMembers
      },
      {
        path: "members/:id",
        name: "concierge-member-profile",
        component: ConciergeSingleMember
      },
      {
        path: "companies",
        name: "companies",
        component: ConciergeCompanies,
        children: [
          {
            path: "private-office",
            name: "private-office",
            props: true,
            meta: {
              officeType: "Private Office"
            }
          },
          {
            path: "virtual-office",
            name: "virtual-office",
            props: true,
            meta: {
              officeType: "Virtual Office"
            }
          }
        ]
      },
      {
        path: "events",
        name: "events",
        component: ConciergeEvents
      },
      {
        path: "logs",
        name: "Activity",
        component: Logs
      },
      {
        path: "booking/:id",
        component: ConciergeBooking,
        children: [
          {
            path: "",
            name: "concierge-booking",
            component: ConciergeBookingOrder
          },
          {
            path: "invoice/:invoiceId",
            name: "concierge-invoice",
            component: ConciergeBookingInvoice
          }
        ]
      },
      {
        path: "profile",
        name: "profile",
        component: ConciergeProfile
      }
    ]
  }
];
